export enum ContractAnalysisStatusEnum {
  AI = 'AI',
  FALLBACK = 'FALLBACK',
  MANUAL = 'MANUAL',
}
